export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE'

export const toggleCollapse = () => ({ type: TOGGLE_COLLAPSE })
